const ERROR = 1;
const SUCCESS = 2;

export { ERROR, SUCCESS };
